var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('remote-js',{attrs:{"src":"https://a.amap.com/jsapi_demos/static/demo-center/js/demoutils.js"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }